import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL = "/logo.png";

const NAV_LINKS = [
  { href: "#how-it-works", label: "How It Works" },
  { href: "#menu", label: "Packages" },
  { href: "#menu", label: "Order Now" },
  { href: "#gallery", label: "Gallery" },
  { href: "#testimonials", label: "Reviews" },
  { href: "#faq", label: "FAQ" },
  { href: "/track", label: "Track Order", external: true },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-black/95 backdrop-blur-md border-b border-[#D4AF37]/20"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        <a href="#hero" data-testid="nav-logo-link" className="shrink-0">
          <img
            src={LOGO_URL}
            alt="Vicki Ann's Luxurious Gifts"
            className="h-14 object-contain"
          />
        </a>

        <div className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-[#D4AF37]/80 hover:text-[#F7EF8A] transition-colors duration-300 font-montserrat text-xs tracking-[0.2em] uppercase"
            >
              {link.label}
            </a>
          ))}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden text-[#D4AF37]"
          data-testid="mobile-menu-toggle"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-black/98 backdrop-blur-md border-t border-[#D4AF37]/20 px-6 py-8 flex flex-col gap-6">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-[#D4AF37] font-montserrat text-sm tracking-[0.2em] uppercase py-1 border-b border-[#D4AF37]/10"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
